// Spread onto free-text fields (e.g. order notes) so browser and
// password-manager card autofill can't drop values like the card expiry
// date into them.
const noAutofillProps = {
  autoComplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-form-type': 'other',
};

export default noAutofillProps;
